import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
const tomos = [{
  icon: '📕',
  title: 'TOMO 1 Base Profesional: Tu marco, tu ética y tus límites',
  pages: '55 páginas',
  subtitle: 'La base que te da seguridad y criterio desde el día uno',
  description: 'Incluye tu marco profesional completo, guía de ética y límites, acuerdo de sesión personalizable, checklist pre y post sesión, y cómo manejar casos difíciles con lenguaje claro y cuidadoso.'
}, {
  icon: '📗',
  title: 'TOMO 2 Intake PRO: Cómo preparar una sesión con foco real',
  pages: '60 páginas',
  subtitle: 'Entrá a cada sesión con dirección clara, sin improvisar',
  description: 'Formulario de intake completo, mapa de intención para transformar consultas vagas en ejes concretos, semáforo de preguntas (verdes, amarillas y rojas) y banco de preguntas poderosas por área: propósito, vínculos, dinero, bloqueos y decisiones.'
}, {
  icon: '📘',
  title: 'TOMO 3 Guión de Sesión: Estructura minuto a minuto',
  pages: '55 páginas',
  subtitle: 'Sesiones ordenadas, profundas y repetibles',
  description: 'Las 5 fases de una sesión PRO: apertura, intención, exploración, integración y cierre. Cómo tomar notas sin cortar la conexión, frases puente para volver al eje y cómo cerrar sin generar dependencia emocional.'
}, {
  icon: '📙',
  title: 'TOMO 4 Traducción PRO: Del mensaje canalizado al insight accionable',
  pages: '60 páginas',
  subtitle: 'Convertí lo sutil en algo claro y concreto para tu consultante',
  description: 'Método TRI (Tema → Raíz → Integración), banco de temas recurrentes con su traducción práctica, preguntas de profundización por arquetipo y cómo proponer acciones reales sin imponer ni infantilizar.'
}, {
  icon: '📔',
  title: 'TOMO 5 Informe Post-Sesión: Entregá un PDF que impresione y retenga',
  pages: '55 páginas',
  subtitle: 'El entregable que justifica tu precio y fideliza a tu consultante',
  description: 'Estructura completa del informe en 6 bloques, cómo escribir con claridad sin absolutismos, 2 ejemplos de informe completo y plantilla multipágina lista para completar con portada, disclaimer y cierre.'
}, {
  icon: '📒',
  title: 'TOMO 6 Sistema y Flujo de Trabajo: Productividad, agenda y consistencia',
  pages: '50 páginas',
  subtitle: 'Menos agotamiento, más orden y calidad constante',
  description: 'Workflow completo de reserva a seguimiento, tiempos estándar por fase, cómo armar paquetes de sesiones, límites de seguimiento y checklist semanal de la facilitadora para sostenerte energética y profesionalmente.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function TomosSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 md:py-24 px-4 relative bg-mystic-900" data-id="element-229">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-230"></div>

      <div className="max-w-6xl mx-auto" data-id="element-231">
        <div className="text-center mb-8 md:mb-16" data-id="element-232">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold mb-4 md:mb-6" data-id="element-233">
            ¿Qué incluye el{' '}
            <span className="text-gradient-gold" data-id="element-234">Sistema Pro</span>?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-6 md:mb-8" data-id="element-235">
            Dentro de SISTEMA PRO REGISTROS AKÁSHICOS encontrás todo lo que
            necesitás para entregar lecturas profesionales con confianza.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="inline-flex flex-col items-center p-4 md:p-6 rounded-2xl border border-gold/30 bg-mystic-800/50 backdrop-blur-sm" data-id="element-236">
            <span className="text-gold font-bold tracking-widest mb-1 md:mb-2 text-[12px] md:text-[14px]" data-id="element-237">
              ✦ LO QUE INCLUYE EL SISTEMA ✦
            </span>
            <span className="text-gray-300 text-xs md:text-sm lg:text-base" data-id="element-238">
              6 tomos profesionales · 6 bonos exclusivos · Acceso inmediato ·
              Descarga digital · Listo para usar hoy
            </span>
          </motion.div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-16" data-id="element-239">
          {tomos.map((tomo, index) => <motion.div key={index} variants={itemVariants} className="glass-card rounded-2xl p-5 md:p-8 hover:border-gold/50 transition-colors duration-300 flex flex-col h-full relative overflow-hidden group" data-id="element-240">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gold/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-241"></div>

              <div className="text-3xl md:text-4xl mb-3 md:mb-4 relative z-10" data-id="element-242">
                {tomo.icon}
              </div>
              <h3 className="text-lg md:text-xl font-serif font-bold text-white mb-2 relative z-10 leading-snug" data-id="element-243">
                {tomo.title}
              </h3>
              <div className="text-gold-light text-xs md:text-sm font-medium mb-2 md:mb-3 relative z-10" data-id="element-244">
                {tomo.pages} · {tomo.subtitle}
              </div>
              <p className="text-gray-400 text-xs md:text-sm leading-relaxed relative z-10 flex-grow" data-id="element-245">
                {tomo.description}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-246">
          <Button onClick={scrollToPricing} className="mb-3 md:mb-4 text-sm md:text-base px-6 py-3 md:px-8 md:py-4" data-id="element-247">
            Quiero el Sistema Completo
          </Button>
          <p className="text-gray-400 text-xs md:text-sm" data-id="element-248">
            Acceso inmediato · Descarga digital · Listo para usar hoy
          </p>
        </motion.div>
      </div>
    </section>;
}